export const Divider = () => {
  return <div className="m-2 h-[1px] w-auto bg-stone-200 dark:bg-stone-700" />;
};
